import axiosClient from './axiosClient';

// Historial de boletas y facturas emitidas (ver InvoicesListPage). La emision, reenvio,
// descarga, envio por correo y anulacion de un comprobante puntual siguen viviendo en
// ordersApi (se gestionan por pedido, no por comprobante, ver OrderDetailDialog).
const invoicesApi = {
  getInvoices: (params) => axiosClient.get('/invoices', { params }),
};

export default invoicesApi;
